export interface FaqItem {
  question: string;
  answer: string;
}

export const faqList: FaqItem[] = [
  {
    question: '鲍鱼礼盒的保质期是多久？',
    answer: '鲜鲍礼盒在冷藏条件下（0-4℃）保质期为7天，建议收到后尽快食用。干鲍礼盒在常温干燥环境下保质期可达12个月，开封后需密封保存并尽快食用。冷冻鲍鱼在-18℃条件下保质期为6个月。',
  },
  {
    question: '如何保存鲍鱼礼盒？',
    answer: '鲜鲍鱼需冷藏保存（0-4℃），请勿冷冻以免影响口感。干鲍鱼需置于阴凉干燥处，避免阳光直射和潮湿环境。已泡发的鲍鱼可以连汤汁一起冷冻保存，保质期3个月。',
  },
  {
    question: '可以定制礼盒内容吗？',
    answer: '当然可以！我们提供灵活的礼盒定制服务。您可以根据预算和需求，自由搭配鲍鱼品种、规格和配套产品（如鲍汁、红酒、茶叶等）。企业批量定制还可加印公司logo和定制贺卡，详情请联系客服400-888-9999。',
  },
  {
    question: '配送方式是怎样的？',
    answer: '我们采用顺丰冷链配送，全国主要城市均可送达。下单后24小时内发货，一线城市次日可达，其他城市2-3天送达。所有订单均免费配送，并提供实时物流追踪服务。',
  },
  {
    question: '收到产品不满意可以退换吗？',
    answer: '我们提供7天无理由退换服务。如您对收到的产品不满意，请在签收后7天内联系客服，我们将为您办理退换货。若产品存在质量问题，我们将在确认后全额退款并承担退货运费。',
  },
  {
    question: '企业团购有优惠吗？',
    answer: '企业团购享受专属优惠价格。10盒以上享9折优惠，50盒以上享8.5折优惠，100盒以上享8折优惠。此外，企业团购还可享受免费定制包装和贺卡服务。详情请联系企业专属客服400-888-9999转2。',
  },
  {
    question: '鲍鱼应该怎么烹饪？',
    answer: '鲜鲍鱼推荐清蒸或炖汤，以保留原汁原味。干鲍鱼需先泡发3-5天，然后用小火慢炖4-6小时，可搭配老母鸡、火腿等食材炖煮，汤汁浓郁鲜美。每份礼盒内都附有详细的烹饪指南，让您轻松烹制美味鲍鱼。',
  },
  {
    question: '鲍鱼的头数是什么意思？',
    answer: '"头数"是衡量鲍鱼规格的标准单位，指的是每斤（500克）中包含的鲍鱼数量。例如，"6头鲍"表示每斤约6只鲍鱼，个头较大；"12头鲍"表示每斤约12只，个头较小。头数越小，单只鲍鱼越大，通常品质和价格也越高。',
  },
];